
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/spaces/[id]",
      function () {
        return require("private-next-pages/spaces/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/spaces/[id]"])
      });
    }
  